import React from "react";
import PropTypes from "prop-types";
import { GatsbyImage as Image } from "gatsby-plugin-image";

const ProjectFeature = ({ projectTitle, title, description, leftImage, rightImage, titleTag = "h2" }) => {
	const TitleTag = titleTag;
	const TextContentMarkup = (
		<div className="project-feature__content">
			{title && (
				<TitleTag className="project-feature__title medium-title">
					{title}
				</TitleTag>
			)}

			{description && (
				<p className="project-feature__description">
					{description}
				</p>
			)}
		</div>
	);

	return (
		<section className="project-feature">
			<div className="project-feature__wrapper container container--medium">
				<div className="project-feature__layout">
					<div className="project-feature__column project-feature__column--left">
						<Image
							className="project-feature__image project-feature__image--left"
							image={leftImage.localFile?.childImageSharp?.gatsbyImageData}
							alt={leftImage.altText || projectTitle}
							title={leftImage.altText || projectTitle}
						/>
					</div>

					{TextContentMarkup}

					<div className="project-feature__column project-feature__column--right">
						<Image
							className="project-feature__image project-feature__image--right"
							image={rightImage.localFile?.childImageSharp?.gatsbyImageData}
							alt={rightImage.altText || projectTitle}
							title={leftImage.altText || projectTitle}
						/>
					</div>
				</div>
			</div>
		</section>
	);
};

ProjectFeature.propTypes = {
	projectTitle: PropTypes.string.isRequired,
	title: PropTypes.string,
	description: PropTypes.string,
	leftImage: PropTypes.object.isRequired,
	rightImage: PropTypes.object.isRequired,
	titleTag: PropTypes.oneOf(["h2", "h3"])
};

export default ProjectFeature;
